<script lang="ts">
    import { storeLanguage, lang_fr } from "../scripts/store";
</script>
    
<style lang="scss">

    .homeshowcase {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: 600px;
        background-image: url("../assets/images/Collectif-1920-1080-px-3.png");
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center 20px;
        background-attachment: scroll;
        color: $color_white;
        &__waves {
            background-image: url("../assets/images/homeshowcase-waves.png");
            background-repeat: repeat-x;
            height: 100px;
            width: 100%;
            transform: translateY(10px);
        }
        &__title {
            margin: 100px 0 0 0;
            font-size: 42px;
            font-weight: 900;
            letter-spacing: 10px;
            text-transform: uppercase;
        }
        &__logo {
            margin: 100px 0 0 0;
            &__img {
                width: 320px;
                opacity: 0.8;
            }
        }
    }

    @include large {
        .homeshowcase {
            height: 950px;
            &__waves {
                transform: translateY(20px);
            }
            &__title {
                font-size: 120px;
            }
            &__logo {
                &__img {
                    width: 640px;
                }
            }
        }
    }

</style>

<div class="homeshowcase">
    <div class="homeshowcase__waves"></div>
    <div class="homeshowcase__title">
        {#if ($storeLanguage == $lang_fr)}
        COLLECTIF
        {:else}
        COLLECTIVE
        {/if}
    </div>
    <div class="homeshowcase__logo"><img class="homeshowcase__logo__img" src="../assets/images/logo.png" alt="logo"></div>
</div>